import * as React from "react";
const SvgCircle = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("rect", {
	x: .5,
	y: .5,
	width: 13,
	height: 13,
	rx: 6.5,
	fill: "#F2F3F7",
	stroke: "#969FA8"
}));
export default SvgCircle;
